module.exports = __webpack_public_path__ + "img/sand-decal-23.302b12c2.png";